import React, { FC } from 'react';
import { Grid, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import useSelector from '../../../../../hooks/useSelector';
import { displayRoofConstructionCheck } from '../../../../../store/registration/selectors';
import { DetailingStep } from '../../../utils/registerEnums';

import { BygningsformCheckBox, StepCheckBox, VeggerCheckBox, VinduerCheckBox } from './components';

export const DetailingCheckBoxes: FC = () => {
  const { t } = useTranslation();

  const displayRoofCheck = useSelector(displayRoofConstructionCheck);

  return (
    <Grid item xs={12} m={2}>
      <Typography variant="h2" gutterBottom>
        {t('register.basicInformation.buildingDetails.title')}
      </Typography>
      <Typography gutterBottom className="text-preline">
        {t('register.basicInformation.buildingDetails.description')}
      </Typography>
      <Grid container>
        <BygningsformCheckBox />

        <VeggerCheckBox />

        <VinduerCheckBox />

        {displayRoofCheck && <StepCheckBox step={DetailingStep.Takkonstruksjon} />}

        <StepCheckBox step={DetailingStep.Gulv} />

        <StepCheckBox step={DetailingStep.Ytterdorer} />

        <StepCheckBox step={DetailingStep.Energibruk} />

        <StepCheckBox step={DetailingStep.Lekkasjetall} />
      </Grid>
    </Grid>
  );
};
